import { Inject, Injectable, Injector } from '@angular/core';



@Injectable({ providedIn: 'root' })
export class WorkOrders_ReportService {

  constructor(
    private injector: Injector
  ) {
  }

  public WorkOrders: WorkOrders_ReportService = this;

  // injecting lazily in order to avoid circular dependencies
}

